/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  bus
} from '../../main';
import {
  mapGetters,
  mapState
} from 'vuex';
export default {
  name: 'note-files-edit',
  components: {},
  props: ['noteFileId'],
  data() {
    return {
      file: '',
      name: '',
      description: '',
      submitted: false,
      uploadFileName: '',
      uploadingLoader: false,
    }
  },
  computed: {
    ...mapGetters([
      'getuserNoteFilesListState'
    ]),
    getFilesFun(){
      this.$store.dispatch('getUserNoteFilesById', {id : this.noteFileId}).then(response => {
        this.name = this.$store.getters.getuserNoteFilesListState.data.name
        this.description = this.$store.getters.getuserNoteFilesListState.data.description
        this.file = this.$store.getters.getuserNoteFilesListState.data.file
        if(this.file){
          let extension = this.file.substr((this.file.lastIndexOf('/') + 1));
          extension = extension.substring(0, extension.lastIndexOf("?"));
          this.uploadFileName = extension
        }
      })
    }
  },
  mounted() {
    this.getFilesFun
  },
  methods: {
    handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadFileName = this.files.name
      } else {
        this.uploadFileName = '';
      }
    },
    validateFileBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.uploadingLoader = true
          let formData = new FormData();
          formData.append('name', this.name);
          formData.append('description', this.description);
          if (this.files)
            formData.append('file', this.files);
          $('.courseloader').show();
          this.$store.dispatch('updatedUserNoteFilesById', { data:{
            data:formData,
            id:this.noteFileId
          }}).then(response => {
            if (response.status === 200) {
              toast.success(response.data.msg);
              this.$validator.reset();
              $('.courseloader').hide();
              bus.$emit('HideEditNoteFilePopup', {
                status: false,
                reload: true
              })
            }
          }).catch(err => {
            console.error(err);
            $('.courseloader').hide();
            this.popupCloseFun()
          })
          return
        }
      });
    },
    popupCloseFun() {
      bus.$emit('HideEditNoteFilePopup', {
        status: false,
        reload: false
      })
    },
  }
}